import { formatTL, effectivePrice } from "@/lib/api";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export const buildPriceListHtml = (products, cats) => {
  const active = products.filter((p) => p.active !== false);
  const order = [...cats, ...new Set(active.map((p) => p.category).filter((c) => !cats.includes(c)))];
  const sections = order
    .map((cat) => {
      const items = active.filter((p) => p.category === cat);
      if (!items.length) return "";
      const rows = items
        .map((p) => {
          const ep = effectivePrice(p);
          const old = ep < p.price ? `<s>${formatTL(p.price)}</s> ` : "";
          return `<div class="row"><span class="name">${esc(p.name)}</span><span class="dots"></span><span class="price">${old}${formatTL(ep)}</span></div>`;
        })
        .join("");
      return `<section><h2>${esc(cat)}</h2>${rows}</section>`;
    })
    .join("");
  return `<!doctype html><html><head><meta charset="utf-8"><title>Fiyat Listesi</title><style>
  @page { size: A4 portrait; margin: 10mm; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Arial Black', Arial, sans-serif; color: #111; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  header { text-align: center; padding: 6mm 0 5mm; border-bottom: 3px solid #d62828; margin-bottom: 6mm; }
  header img { height: 32mm; }
  header h1 { font-size: 30px; letter-spacing: 3px; color: #d62828; margin-top: 2mm; }
  main { columns: 2; column-gap: 10mm; }
  section { break-inside: avoid; margin-bottom: 7mm; }
  h2 { background: #d62828; color: #fff; font-size: 18px; padding: 2mm 4mm; border-radius: 3mm; margin-bottom: 3mm; text-transform: uppercase; letter-spacing: 1px; }
  .row { display: flex; align-items: baseline; gap: 2mm; font-size: 15px; padding: 1.6mm 1mm; font-family: Arial, sans-serif; font-weight: 700; }
  .name { flex-shrink: 1; }
  .dots { flex: 1; border-bottom: 2px dotted #999; transform: translateY(-1mm); min-width: 6mm; }
  .price { white-space: nowrap; font-weight: 900; font-size: 17px; color: #d62828; }
  .price s { color: #888; font-size: 13px; font-weight: 700; margin-right: 1mm; }
  footer { text-align: center; margin-top: 4mm; font-family: Arial, sans-serif; font-size: 11px; color: #666; }
  </style></head><body>
  <header><img src="${window.location.origin}/logo.jpeg" alt="Deny's Burger & Fries"/><h1>FİYAT LİSTESİ</h1></header>
  <main>${sections}</main>
  <footer>Fiyatlarımıza KDV dahildir · ${new Date().toLocaleDateString("tr-TR")}</footer>
  </body></html>`;
};

export const printPriceList = (products, cats) => {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(buildPriceListHtml(products, cats));
  w.document.close();
  w.focus();
  w.onload = () => setTimeout(() => w.print(), 300);
  return true;
};
